export var extractChildren = function (children) {
    var _a;
    if (!Array.isArray(children))
        return children;
    if (children[0] && typeof children[0] == 'function')
        return children[0];
    return (_a = []).concat.apply(_a, children);
};
